/* ==========================================================================================================
 * NORDHOLZ – Konfigurator-Button "Selbst wählen & sparen" (immer sichtbar)
 * ----------------------------------------------------------------------------------------------------------
 * Problem:
 * Auf der PDP "Saunaaufguss Konzentrat 4+1 gratis" wurde der gelbe Button bisher von der App
 * "Easy Bundle Builder" injiziert (<div class="gbbExtBundleRedirectButton"> innerhalb von
 * .gbbExtBundleUpsellWrapper in #MainPaymentContainer). Sobald eine Variante explizit ausgewählt ist
 * (Klick im Varianten-Picker bzw. URL mit ?variant=...), entfernt die App den Button wieder aus dem DOM,
 * weil in der App-Konfiguration (bundleUpsellConfig.showOnSpecificProductPages) für dieses Produkt eine
 * leere Variantenliste hinterlegt ist.
 *
 * Lösung:
 * Der Button wird theme-seitig gerendert und ist damit unabhängig von der App auf jeder Variante sichtbar.
 * Der Container der App wird per CSS ausgeblendet, damit der Button nicht doppelt erscheint.
 *
 * Pflege:
 * Weitere Produktseiten einfach in NH_CONFIGURATOR_BUTTON.pages ergänzen.
 * ========================================================================================================== */
window.NH_CONFIGURATOR_BUTTON = window.NH_CONFIGURATOR_BUTTON || {
  pages: [
    {
      handle: 'saunaaufguss-konzentrat-4-1-gratis',
      url: '/products/4-1',
      label: 'Selbst wählen & sparen'
    }
  ]
};

(function () {
  'use strict';

  var STYLE_ID = 'nh-configurator-button-styles';
  var MARKER = 'data-nh-configurator-button';

  function currentPage() {
    var pages = (window.NH_CONFIGURATOR_BUTTON && window.NH_CONFIGURATOR_BUTTON.pages) || [];
    var path = window.location.pathname;

    for (var i = 0; i < pages.length; i++) {
      if (path.indexOf('/products/' + pages[i].handle) !== -1) {
        return pages[i];
      }
    }

    return null;
  }

  function injectStyles() {
    if (document.getElementById(STYLE_ID)) {
      return;
    }

    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      '.gbbExtBundleUpsellWrapper { display: none !important; }',
      '.nh-configurator-button {',
      '  display: grid;',
      '  place-items: center;',
      '  width: 100%;',
      '  min-height: 45px;',
      '  margin: 8px 0 0;',
      '  padding: 14px 24px;',
      '  box-sizing: border-box;',
      '  background-color: #f0c14b;',
      '  color: #111111;',
      '  border: 1.25px solid #a88734;',
      '  border-radius: 10px;',
      '  box-shadow: inset 0 1px 0 0 #ffffff;',
      '  font-family: Cabin, sans-serif;',
      '  font-size: 16px;',
      '  font-weight: 600;',
      '  line-height: 1.2;',
      '  letter-spacing: 0.8px;',
      '  text-transform: uppercase;',
      '  text-align: center;',
      '  text-decoration: none;',
      '  cursor: pointer;',
      '  transition: filter 0.15s ease;',
      '}',
      '.nh-configurator-button:hover,',
      '.nh-configurator-button:focus {',
      '  color: #111111;',
      '  text-decoration: none;',
      '  filter: brightness(0.96);',
      '}',
      '.nh-configurator-button:focus-visible {',
      '  outline: 2px solid #111111;',
      '  outline-offset: 2px;',
      '}'
    ].join('\n');

    (document.head || document.documentElement).appendChild(style);
  }

  function buildButton(page) {
    var link = document.createElement('a');

    link.className = 'nh-configurator-button';
    link.href = page.url;
    link.textContent = page.label;
    link.setAttribute(MARKER, '');

    return link;
  }

  function mount(page) {
    var container = document.getElementById('MainPaymentContainer');

    if (!container || container.querySelector('[' + MARKER + ']')) {
      return;
    }

    container.appendChild(buildButton(page));
  }

  function init() {
    var page = currentPage();

    if (!page) {
      return;
    }

    injectStyles();
    mount(page);

    document.addEventListener('variant:changed', function () {
      mount(page);
    });

    if (window.MutationObserver) {
      var scheduled = false;

      new MutationObserver(function () {
        if (scheduled) {
          return;
        }

        scheduled = true;

        window.setTimeout(function () {
          scheduled = false;
          mount(page);
        }, 100);
      }).observe(document.documentElement, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
